import { StringReplacePipe } from '../../../../../_helpers/_pipes/string-replace.pipe';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, Input } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, StringReplacePipe],
  selector: 'app-billing-header',
  templateUrl: './billing-header.component.html',
  styleUrls: ['./billing-header.component.scss']
})
export class BillingHeaderComponent{
  @Input() policyTypeImg;
  @Input() policyType: string;
  @Input() policy?: any;
  @Input() policyNumber: number;
}
